/* eslint-disable semi */
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import { RouterAlterer } from '@/core/libs';
import { routes } from './routes';

// Router設定
Vue.use(Router);

// ルーターの設定
const router = new Router({
  routes,
  mode: 'history',
  parseQuery: RouterAlterer.parseQuery,
  stringifyQuery: RouterAlterer.stringifyQuery
});

// 共有ヒストリ
const AppRouterHistory = {
  history: {},
  clear: function () {
    this.history = {};
  },
  push: function (to) {
    this.history[to.name] = to;
  },
  get: function (name) {
    return this.history[name];
  }
}

// ログイン認証設定
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.parent) {
    // 親階層の定義があるページの場合は履歴保持
  } else {
    // 親階層の定義がないページの場合は履歴クリア
    AppRouterHistory.clear();
  }

  // キャッシュが有効な場合のみ履歴をキャッシュに登録
  // if (to.meta && to.meta.cache) {
  //   AppRouterHistory.push(to);
  // }
  AppRouterHistory.push(to);

  // 認証期限チェック&延長
  if (store().getters.isLogin && store().getters.isExpired) {
    store().dispatch('logout');
  } else {
    store().dispatch('alive');
  }

  // 認証チェック
  if (!to.meta.isPublic && !store().getters.isLogin) {
    // ログインページへ遷移
    next({ name: 'LOGIN', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

// 画面遷移時にスクロールを上部に設定
router.afterEach((to, from) => {
  try {
    window.scrollTo({
      top: 0
    });
  } catch (e) {}
});

/**
 * ルート設定のキャッシュ
 */
const RoutesMap = {};

/**
 * ルート設定キャッシュの初期化
 */
function initializeRoutesCache (routes) {
  if (routes) {
    routes.forEach(element => {
      if ('name' in element && element.meta && element.meta.title) {
        RoutesMap[element.name] = {
          name: element.name,
          parent: element.meta.parent,
          title: element.meta.title,
          path: element.path,
          propsAlias: element.meta.propsAlias
        };
      }
      if ('children' in element) {
        initializeRoutesCache(element.children);
      }
    });
  }
}
initializeRoutesCache(routes);

export default router;
export { AppRouterHistory, RoutesMap };



// WEBPACK FOOTER //
// ./src/router/index.js